import React, { useState } from 'react';
import { supabase } from '../supabase';
import logo from '../logo.png';

const USERS = {
  jared:  { id:'jared',  name:'Jared Gavard',    role:'admin',  repId:'jared',  pass:'JGadmin2026' },
  justin: { id:'justin', name:'Justin Gavard',   role:'admin',  repId:'justin', pass:'JGadmin2026' },
  peter:  { id:'peter',  name:'Peter Povey',     role:'rep',    repId:'peter',  pass:'peter2026' },
  mitch:  { id:'mitch',  name:'Mitch Jankowski', role:'rep',    repId:'mitch',  pass:'mitch2026' },
  sarah:  { id:'sarah',  name:'Sarah Sutter',    role:'rep',    repId:'sarah',  pass:'sarah2026' },
  dan:    { id:'dan',    name:'Dan Pena',         role:'rep',    repId:'dan',    pass:'dan2026' },
  barry:  { id:'barry',  name:'Barry-Lynn',       role:'rep',    repId:'barry',  pass:'barry2026' },
  kelsey: { id:'kelsey', name:'Kelsey Gavard',    role:'rep',    repId:'kelsey', pass:'kelsey2026' },
};

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = USERS[username.trim().toLowerCase()];
    if (!user || user.pass !== password) {
      setError('Incorrect username or password.');
      return;
    }
    setError('');
    onLogin(user);
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <img src={logo} alt="JG Graphics" />
          <div>
            <div className="login-logo-text">JG Graphics</div>
            <div className="login-logo-sub">Sales Dashboard 2026</div>
          </div>
        </div>
        <div className="login-title">Sign in</div>
        <div className="login-sub">Access your sales performance data</div>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Username</label>
            <input
              type="text" value={username} autoComplete="username"
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
            />
          </div>
          <div className="field">
            <label>Password</label>
            <input
              type="password" value={password} autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>
          <button type="submit" className="btn-primary">Sign in</button>
        </form>
        <div className="login-hint">Contact your admin if you need access</div>
      </div>
    </div>
  );
}
